/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinkshelp2Inputs */

const en_downloadlinkshelp2 = /** @type {(inputs: Downloadlinkshelp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every tap on the link is counted. People = different devices per day. Downloads per link are in App Store Connect (Campaigns) and the Google Play Console.`)
};

const de_downloadlinkshelp2 = /** @type {(inputs: Downloadlinkshelp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Tipp auf den Link wird gezählt. Personen = verschiedene Geräte pro Tag. Downloads pro Link siehst du in App Store Connect (Kampagnen) und in der Google Play Console.`)
};

/**
* | output |
* | --- |
* | "Every tap on the link is counted. People = different devices per day. Downloads per link are in App Store Connect (Campaigns) and the Google Play Console." |
*
* @param {Downloadlinkshelp2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinkshelp2 = /** @type {((inputs?: Downloadlinkshelp2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinkshelp2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinkshelp2(inputs)
	return de_downloadlinkshelp2(inputs)
});
export { downloadlinkshelp2 as "downloadLinksHelp" }